import { createReducer, on } from '@ngrx/store';
import { documentStateType } from '../../core/models/Interfaces/documents';
import {
  addDocument,
  documentsFailed,
  documentsReceived,
  documentsReset,
  getDocumentTypes,
  getDocumentTypesFailed,
  getDocumentTypesReceived,
  getDocuments,
} from '../actions/documentsTabActions';

const initialState: documentStateType = {
  isDocumentFetchingSuccessfull: false,
  isFetchingDocuments: false,
  isDocumentFechingFailed: false,
  documentsData: null,
  documentTypes: null,
  isFetchingDocumentTypes: false,
  isFetchingDocumentFailed: false,
  isFetchingDocumentSuccess: false,
  addDocumentSubmitting: false,
};

export const docuementsReducer = createReducer(
  initialState,
  on(getDocuments, (state) => {
    return {
      ...state,
      isFetchingDocuments: true,
      documentsData: [],
      addDocumentSubmitting: false,
    };
  }),
  on(documentsReceived, (state, { data }: any) => {
    return {
      ...state,
      isDocumentFetchingSuccessfull: true,
      isFetchingDocuments: false,
      documentsData: data,
      isAddDocumentSuccessfull: false,
    };
  }),
  on(documentsReset, (state, { data }: any) => {
    return {
      ...state,
      isDocumentFetchingSuccessfull: false,
      isFetchingDocuments: false,
      documentsData: null,
    };
  }),
  on(documentsFailed, (state) => {
    return {
      ...state,
      isDocumentFetchingSuccessfull: false,
      isFetchingDocuments: false,
      isDocumentFechingFailed: true,
      documentsData: null,
    };
  }),
  on(getDocumentTypes, (state, { data }: any) => {
    return {
      ...state,
      documentTypes: null,
      isFetchingDocumentSuccess: false,
      isFetchingDocumentFailed: false,
      isFetchingDocumentTypes: true,
    };
  }),
  on(getDocumentTypesReceived, (state, { data }: any) => {
    return {
      ...state,
      documentTypes: data,
      isFetchingDocumentSuccess: true,
      isFetchingDocumentFailed: false,
    };
  }),
  on(getDocumentTypesFailed, (state, { data }: any) => {
    return {
      ...state,
      documentTypes: data,
      isFetchingDocumentFailed: true,
      isFetchingDocumentSuccess: false,
    };
  }),
  on(addDocument, (state) => {
    return { ...state, addDocumentSubmitting: true };
  }),
);
